import React from "react";
import Select from "react-select";
import { COUNTRIES } from "../../constants";

const CountrySelect = ({ selectedCountry, onCountryChange }) => {
    const options = COUNTRIES.map((country) => ({
        label: (
            <div style={{ display: "flex", alignItems: "center", fontSize: "15px" }}>
                <img
                    src={`https://flagcdn.com/w40/${country.region.toLowerCase()}.png`}
                    alt={country.name}
                    style={{ width: 24, height: 16, marginRight: 10 }}
                />
                {country.name}
            </div>
        ),
        value: country.region,
        savedValue: country.name,
    }));

    const handleChange = (selectedOption) => {
        onCountryChange(selectedOption.savedValue); // Update Formik's state
    };
    return (
        <div className="d-flex align-items-center" style={{ paddingTop: "30px"}}>

            <Select
                options={options}
                label="Select Country"
                value={options.find(option => option.savedValue == selectedCountry)}
                onChange={handleChange}
                styles={{
                    control: (provided, state) => ({
                        ...provided,
                        border: "none",
                        width:'400px',
                        boxShadow: state.isFocused ? "none" : provided.boxShadow,
                        outline: "none",
                    })
                }}
                className="country-select"
            />
        </div>
    );
};

export default CountrySelect;
